@file:Suppress("unused")

package theme

import androidx.compose.runtime.Stable
import androidx.compose.ui.graphics.Color

// Red
@Stable
val Color.Companion.Red50 get() = Color(0xFFFFEBEE)

@Stable
val Color.Companion.Red100 get() = Color(0xFFFFCDD2)

@Stable
val Color.Companion.Red200 get() = Color(0xFFEF9A9A)

@Stable
val Color.Companion.Red300 get() = Color(0xFFE57373)

@Stable
val Color.Companion.Red400 get() = Color(0xFFEF5350)

@Stable
val Color.Companion.Red500 get() = Color(0xFFF44336)

@Stable
val Color.Companion.Red600 get() = Color(0xFFE53935)

@Stable
val Color.Companion.Red700 get() = Color(0xFFD32F2F)

@Stable
val Color.Companion.Red800 get() = Color(0xFFC62828)

@Stable
val Color.Companion.Red900 get() = Color(0xFFB71C1C)

@Stable
val Color.Companion.RedA100 get() = Color(0xFFFF8A80)

@Stable
val Color.Companion.RedA200 get() = Color(0xFFFF5252)

@Stable
val Color.Companion.RedA400 get() = Color(0xFFFF1744)

@Stable
val Color.Companion.RedA700 get() = Color(0xFFD50000)

// Pink
@Stable
val Color.Companion.Pink50 get() = Color(0xFFFCE4EC)

@Stable
val Color.Companion.Pink100 get() = Color(0xFFF8BBD0)

@Stable
val Color.Companion.Pink200 get() = Color(0xFFF48FB1)

@Stable
val Color.Companion.Pink300 get() = Color(0xFFF06292)

@Stable
val Color.Companion.Pink400 get() = Color(0xFFEC407A)

@Stable
val Color.Companion.Pink500 get() = Color(0xFFE91E63)

@Stable
val Color.Companion.Pink600 get() = Color(0xFFD81B60)

@Stable
val Color.Companion.Pink700 get() = Color(0xFFC2185B)

@Stable
val Color.Companion.Pink800 get() = Color(0xFFAD1457)

@Stable
val Color.Companion.Pink900 get() = Color(0xFF880E4F)

@Stable
val Color.Companion.PinkA100 get() = Color(0xFFFF80AB)

@Stable
val Color.Companion.PinkA200 get() = Color(0xFFFF4081)

@Stable
val Color.Companion.PinkA400 get() = Color(0xFFF50057)

@Stable
val Color.Companion.PinkA700 get() = Color(0xFFC51162)

// Purple
@Stable
val Color.Companion.Purple50 get() = Color(0xFFF3E5F5)

@Stable
val Color.Companion.Purple100 get() = Color(0xFFE1BEE7)

@Stable
val Color.Companion.Purple200 get() = Color(0xFFCE93D8)

@Stable
val Color.Companion.Purple300 get() = Color(0xFFBA68C8)

@Stable
val Color.Companion.Purple400 get() = Color(0xFFAB47BC)

@Stable
val Color.Companion.Purple500 get() = Color(0xFF9C27B0)

@Stable
val Color.Companion.Purple600 get() = Color(0xFF8E24AA)

@Stable
val Color.Companion.Purple700 get() = Color(0xFF7B1FA2)

@Stable
val Color.Companion.Purple800 get() = Color(0xFF6A1B9A)

@Stable
val Color.Companion.Purple900 get() = Color(0xFF4A148C)

@Stable
val Color.Companion.PurpleA100 get() = Color(0xFFEA80FC)

@Stable
val Color.Companion.PurpleA200 get() = Color(0xFFE040FB)

@Stable
val Color.Companion.PurpleA400 get() = Color(0xFFD500F9)

@Stable
val Color.Companion.PurpleA700 get() = Color(0xFFAA00FF)

// Deep Purple
@Stable
val Color.Companion.DeepPurple50 get() = Color(0xFFEDE7F6)

@Stable
val Color.Companion.DeepPurple100 get() = Color(0xFFD1C4E9)

@Stable
val Color.Companion.DeepPurple200 get() = Color(0xFFB39DDB)

@Stable
val Color.Companion.DeepPurple300 get() = Color(0xFF9575CD)

@Stable
val Color.Companion.DeepPurple400 get() = Color(0xFF7E57C2)

@Stable
val Color.Companion.DeepPurple500 get() = Color(0xFF673AB7)

@Stable
val Color.Companion.DeepPurple600 get() = Color(0xFF5E35B1)

@Stable
val Color.Companion.DeepPurple700 get() = Color(0xFF512DA8)

@Stable
val Color.Companion.DeepPurple800 get() = Color(0xFF4527A0)

@Stable
val Color.Companion.DeepPurple900 get() = Color(0xFF311B92)

@Stable
val Color.Companion.DeepPurpleA100 get() = Color(0xFFB388FF)

@Stable
val Color.Companion.DeepPurpleA200 get() = Color(0xFF7C4DFF)

@Stable
val Color.Companion.DeepPurpleA400 get() = Color(0xFF651FFF)

@Stable
val Color.Companion.DeepPurpleA700 get() = Color(0xFF6200EA)

// Indigo
@Stable
val Color.Companion.Indigo50 get() = Color(0xFFE8EAF6)

@Stable
val Color.Companion.Indigo100 get() = Color(0xFFC5CAE9)

@Stable
val Color.Companion.Indigo200 get() = Color(0xFF9FA8DA)

@Stable
val Color.Companion.Indigo300 get() = Color(0xFF7986CB)

@Stable
val Color.Companion.Indigo400 get() = Color(0xFF5C6BC0)

@Stable
val Color.Companion.Indigo500 get() = Color(0xFF3F51B5)

@Stable
val Color.Companion.Indigo600 get() = Color(0xFF3949AB)

@Stable
val Color.Companion.Indigo700 get() = Color(0xFF303F9F)

@Stable
val Color.Companion.Indigo800 get() = Color(0xFF283593)

@Stable
val Color.Companion.Indigo900 get() = Color(0xFF1A237E)

@Stable
val Color.Companion.IndigoA100 get() = Color(0xFF8C9EFF)

@Stable
val Color.Companion.IndigoA200 get() = Color(0xFF536DFE)

@Stable
val Color.Companion.IndigoA400 get() = Color(0xFF3D5AFE)

@Stable
val Color.Companion.IndigoA700 get() = Color(0xFF304FFE)

// Blue
@Stable
val Color.Companion.Blue50 get() = Color(0xFFE3F2FD)

@Stable
val Color.Companion.Blue100 get() = Color(0xFFBBDEFB)

@Stable
val Color.Companion.Blue200 get() = Color(0xFF90CAF9)

@Stable
val Color.Companion.Blue300 get() = Color(0xFF64B5F6)

@Stable
val Color.Companion.Blue400 get() = Color(0xFF42A5F5)

@Stable
val Color.Companion.Blue500 get() = Color(0xFF2196F3)

@Stable
val Color.Companion.Blue600 get() = Color(0xFF1E88E5)

@Stable
val Color.Companion.Blue700 get() = Color(0xFF1976D2)

@Stable
val Color.Companion.Blue800 get() = Color(0xFF1565C0)

@Stable
val Color.Companion.Blue900 get() = Color(0xFF0D47A1)

@Stable
val Color.Companion.BlueA100 get() = Color(0xFF82B1FF)

@Stable
val Color.Companion.BlueA200 get() = Color(0xFF448AFF)

@Stable
val Color.Companion.BlueA400 get() = Color(0xFF2979FF)

@Stable
val Color.Companion.BlueA700 get() = Color(0xFF2962FF)

// Light Blue
@Stable
val Color.Companion.LightBlue50 get() = Color(0xFFE1F5FE)

@Stable
val Color.Companion.LightBlue100 get() = Color(0xFFB3E5FC)

@Stable
val Color.Companion.LightBlue200 get() = Color(0xFF81D4FA)

@Stable
val Color.Companion.LightBlue300 get() = Color(0xFF4FC3F7)

@Stable
val Color.Companion.LightBlue400 get() = Color(0xFF29B6F6)

@Stable
val Color.Companion.LightBlue500 get() = Color(0xFF03A9F4)

@Stable
val Color.Companion.LightBlue600 get() = Color(0xFF039BE5)

@Stable
val Color.Companion.LightBlue700 get() = Color(0xFF0288D1)

@Stable
val Color.Companion.LightBlue800 get() = Color(0xFF0277BD)

@Stable
val Color.Companion.LightBlue900 get() = Color(0xFF01579B)

@Stable
val Color.Companion.LightBlueA100 get() = Color(0xFF80D8FF)

@Stable
val Color.Companion.LightBlueA200 get() = Color(0xFF40C4FF)

@Stable
val Color.Companion.LightBlueA400 get() = Color(0xFF00B0FF)

@Stable
val Color.Companion.LightBlueA700 get() = Color(0xFF0091EA)

// Cyan
@Stable
val Color.Companion.Cyan50 get() = Color(0xFFE0F7FA)

@Stable
val Color.Companion.Cyan100 get() = Color(0xFFB2EBF2)

@Stable
val Color.Companion.Cyan200 get() = Color(0xFF80DEEA)

@Stable
val Color.Companion.Cyan300 get() = Color(0xFF4DD0E1)

@Stable
val Color.Companion.Cyan400 get() = Color(0xFF26C6DA)

@Stable
val Color.Companion.Cyan500 get() = Color(0xFF00BCD4)

@Stable
val Color.Companion.Cyan600 get() = Color(0xFF00ACC1)

@Stable
val Color.Companion.Cyan700 get() = Color(0xFF0097A7)

@Stable
val Color.Companion.Cyan800 get() = Color(0xFF00838F)

@Stable
val Color.Companion.Cyan900 get() = Color(0xFF006064)

@Stable
val Color.Companion.CyanA100 get() = Color(0xFF84FFFF)

@Stable
val Color.Companion.CyanA200 get() = Color(0xFF18FFFF)

@Stable
val Color.Companion.CyanA400 get() = Color(0xFF00E5FF)

@Stable
val Color.Companion.CyanA700 get() = Color(0xFF00B8D4)

// Teal
@Stable
val Color.Companion.Teal50 get() = Color(0xFFE0F2F1)

@Stable
val Color.Companion.Teal100 get() = Color(0xFFB2DFDB)

@Stable
val Color.Companion.Teal200 get() = Color(0xFF80CBC4)

@Stable
val Color.Companion.Teal300 get() = Color(0xFF4DB6AC)

@Stable
val Color.Companion.Teal400 get() = Color(0xFF26A69A)

@Stable
val Color.Companion.Teal500 get() = Color(0xFF009688)

@Stable
val Color.Companion.Teal600 get() = Color(0xFF00897B)

@Stable
val Color.Companion.Teal700 get() = Color(0xFF00796B)

@Stable
val Color.Companion.Teal800 get() = Color(0xFF00695C)

@Stable
val Color.Companion.Teal900 get() = Color(0xFF004D40)

@Stable
val Color.Companion.TealA100 get() = Color(0xFFA7FFEB)

@Stable
val Color.Companion.TealA200 get() = Color(0xFF64FFDA)

@Stable
val Color.Companion.TealA400 get() = Color(0xFF1DE9B6)

@Stable
val Color.Companion.TealA700 get() = Color(0xFF00BFA5)

// Green
@Stable
val Color.Companion.Green50 get() = Color(0xFFE8F5E9)

@Stable
val Color.Companion.Green100 get() = Color(0xFFC8E6C9)

@Stable
val Color.Companion.Green200 get() = Color(0xFFA5D6A7)

@Stable
val Color.Companion.Green300 get() = Color(0xFF81C784)

@Stable
val Color.Companion.Green400 get() = Color(0xFF66BB6A)

@Stable
val Color.Companion.Green500 get() = Color(0xFF4CAF50)

@Stable
val Color.Companion.Green600 get() = Color(0xFF43A047)

@Stable
val Color.Companion.Green700 get() = Color(0xFF388E3C)

@Stable
val Color.Companion.Green800 get() = Color(0xFF2E7D32)

@Stable
val Color.Companion.Green900 get() = Color(0xFF1B5E20)

@Stable
val Color.Companion.GreenA100 get() = Color(0xFFB9F6CA)

@Stable
val Color.Companion.GreenA200 get() = Color(0xFF69F0AE)

@Stable
val Color.Companion.GreenA400 get() = Color(0xFF00E676)

@Stable
val Color.Companion.GreenA700 get() = Color(0xFF00C853)

// Light Green
@Stable
val Color.Companion.LightGreen50 get() = Color(0xFFF1F8E9)

@Stable
val Color.Companion.LightGreen100 get() = Color(0xFFDCEDC8)

@Stable
val Color.Companion.LightGreen200 get() = Color(0xFFC5E1A5)

@Stable
val Color.Companion.LightGreen300 get() = Color(0xFFAED581)

@Stable
val Color.Companion.LightGreen400 get() = Color(0xFF9CCC65)

@Stable
val Color.Companion.LightGreen500 get() = Color(0xFF8BC34A)

@Stable
val Color.Companion.LightGreen600 get() = Color(0xFF7CB342)

@Stable
val Color.Companion.LightGreen700 get() = Color(0xFF689F38)

@Stable
val Color.Companion.LightGreen800 get() = Color(0xFF558B2F)

@Stable
val Color.Companion.LightGreen900 get() = Color(0xFF33691E)

@Stable
val Color.Companion.LightGreenA100 get() = Color(0xFFCCFF90)

@Stable
val Color.Companion.LightGreenA200 get() = Color(0xFFB2FF59)

@Stable
val Color.Companion.LightGreenA400 get() = Color(0xFF76FF03)

@Stable
val Color.Companion.LightGreenA700 get() = Color(0xFF64DD17)

// Lime
@Stable
val Color.Companion.Lime50 get() = Color(0xFFF9FBE7)

@Stable
val Color.Companion.Lime100 get() = Color(0xFFF0F4C3)

@Stable
val Color.Companion.Lime200 get() = Color(0xFFE6EE9C)

@Stable
val Color.Companion.Lime300 get() = Color(0xFFDCE775)

@Stable
val Color.Companion.Lime400 get() = Color(0xFFD4E157)

@Stable
val Color.Companion.Lime500 get() = Color(0xFFCDDC39)

@Stable
val Color.Companion.Lime600 get() = Color(0xFFC0CA33)

@Stable
val Color.Companion.Lime700 get() = Color(0xFFAFB42B)

@Stable
val Color.Companion.Lime800 get() = Color(0xFF9E9D24)

@Stable
val Color.Companion.Lime900 get() = Color(0xFF827717)

@Stable
val Color.Companion.LimeA100 get() = Color(0xFFF4FF81)

@Stable
val Color.Companion.LimeA200 get() = Color(0xFFEEFF41)

@Stable
val Color.Companion.LimeA400 get() = Color(0xFFC6FF00)

@Stable
val Color.Companion.LimeA700 get() = Color(0xFFAEEA00)

// Yellow
@Stable
val Color.Companion.Yellow50 get() = Color(0xFFFFFDE7)

@Stable
val Color.Companion.Yellow100 get() = Color(0xFFFFF9C4)

@Stable
val Color.Companion.Yellow200 get() = Color(0xFFFFF59D)

@Stable
val Color.Companion.Yellow300 get() = Color(0xFFFFF176)

@Stable
val Color.Companion.Yellow400 get() = Color(0xFFFFEE58)

@Stable
val Color.Companion.Yellow500 get() = Color(0xFFFFEB3B)

@Stable
val Color.Companion.Yellow600 get() = Color(0xFFFDD835)

@Stable
val Color.Companion.Yellow700 get() = Color(0xFFFBC02D)

@Stable
val Color.Companion.Yellow800 get() = Color(0xFFF9A825)

@Stable
val Color.Companion.Yellow900 get() = Color(0xFFF57F17)

@Stable
val Color.Companion.YellowA100 get() = Color(0xFFFFFF8D)

@Stable
val Color.Companion.YellowA200 get() = Color(0xFFFFFF00)

@Stable
val Color.Companion.YellowA400 get() = Color(0xFFFFEA00)

@Stable
val Color.Companion.YellowA700 get() = Color(0xFFFFD600)

// Amber
@Stable
val Color.Companion.Amber50 get() = Color(0xFFFFF8E1)

@Stable
val Color.Companion.Amber100 get() = Color(0xFFFFECB3)

@Stable
val Color.Companion.Amber200 get() = Color(0xFFFFE082)

@Stable
val Color.Companion.Amber300 get() = Color(0xFFFFD54F)

@Stable
val Color.Companion.Amber400 get() = Color(0xFFFFCA28)

@Stable
val Color.Companion.Amber500 get() = Color(0xFFFFC107)

@Stable
val Color.Companion.Amber600 get() = Color(0xFFFFB300)

@Stable
val Color.Companion.Amber700 get() = Color(0xFFFFA000)

@Stable
val Color.Companion.Amber800 get() = Color(0xFFFF8F00)

@Stable
val Color.Companion.Amber900 get() = Color(0xFFFF6F00)

@Stable
val Color.Companion.AmberA100 get() = Color(0xFFFFE57F)

@Stable
val Color.Companion.AmberA200 get() = Color(0xFFFFD740)

@Stable
val Color.Companion.AmberA400 get() = Color(0xFFFFC400)

@Stable
val Color.Companion.AmberA700 get() = Color(0xFFFFAB00)

// Orange
@Stable
val Color.Companion.Orange50 get() = Color(0xFFFFF3E0)

@Stable
val Color.Companion.Orange100 get() = Color(0xFFFFE0B2)

@Stable
val Color.Companion.Orange200 get() = Color(0xFFFFCC80)

@Stable
val Color.Companion.Orange300 get() = Color(0xFFFFB74D)

@Stable
val Color.Companion.Orange400 get() = Color(0xFFFFA726)

@Stable
val Color.Companion.Orange500 get() = Color(0xFFFF9800)

@Stable
val Color.Companion.Orange600 get() = Color(0xFFFB8C00)

@Stable
val Color.Companion.Orange700 get() = Color(0xFFF57C00)

@Stable
val Color.Companion.Orange800 get() = Color(0xFFEF6C00)

@Stable
val Color.Companion.Orange900 get() = Color(0xFFE65100)

@Stable
val Color.Companion.OrangeA100 get() = Color(0xFFFFD180)

@Stable
val Color.Companion.OrangeA200 get() = Color(0xFFFFAB40)

@Stable
val Color.Companion.OrangeA400 get() = Color(0xFFFF9100)

@Stable
val Color.Companion.OrangeA700 get() = Color(0xFFFF6D00)

// Deep Orange
@Stable
val Color.Companion.DeepOrange50 get() = Color(0xFFFBE9E7)

@Stable
val Color.Companion.DeepOrange100 get() = Color(0xFFFFCCBC)

@Stable
val Color.Companion.DeepOrange200 get() = Color(0xFFFFAB91)

@Stable
val Color.Companion.DeepOrange300 get() = Color(0xFFFF8A65)

@Stable
val Color.Companion.DeepOrange400 get() = Color(0xFFFF7043)

@Stable
val Color.Companion.DeepOrange500 get() = Color(0xFFFF5722)

@Stable
val Color.Companion.DeepOrange600 get() = Color(0xFFF4511E)

@Stable
val Color.Companion.DeepOrange700 get() = Color(0xFFE64A19)

@Stable
val Color.Companion.DeepOrange800 get() = Color(0xFFD84315)

@Stable
val Color.Companion.DeepOrange900 get() = Color(0xFFBF360C)

@Stable
val Color.Companion.DeepOrangeA100 get() = Color(0xFFFF9E80)

@Stable
val Color.Companion.DeepOrangeA200 get() = Color(0xFFFF6E40)

@Stable
val Color.Companion.DeepOrangeA400 get() = Color(0xFFFF3D00)

@Stable
val Color.Companion.DeepOrangeA700 get() = Color(0xFFDD2C00)

// Brown
@Stable
val Color.Companion.Brown50 get() = Color(0xFFEFEBE9)

@Stable
val Color.Companion.Brown100 get() = Color(0xFFD7CCC8)

@Stable
val Color.Companion.Brown200 get() = Color(0xFFBCAAA4)

@Stable
val Color.Companion.Brown300 get() = Color(0xFFA1887F)

@Stable
val Color.Companion.Brown400 get() = Color(0xFF8D6E63)

@Stable
val Color.Companion.Brown500 get() = Color(0xFF795548)

@Stable
val Color.Companion.Brown600 get() = Color(0xFF6D4C41)

@Stable
val Color.Companion.Brown700 get() = Color(0xFF5D4037)

@Stable
val Color.Companion.Brown800 get() = Color(0xFF4E342E)

@Stable
val Color.Companion.Brown900 get() = Color(0xFF3E2723)

// Grey
@Stable
val Color.Companion.Grey50 get() = Color(0xFFFAFAFA)

@Stable
val Color.Companion.Grey100 get() = Color(0xFFF5F5F5)

@Stable
val Color.Companion.Grey200 get() = Color(0xFFEEEEEE)

@Stable
val Color.Companion.Grey300 get() = Color(0xFFE0E0E0)

@Stable
val Color.Companion.Grey400 get() = Color(0xFFBDBDBD)

@Stable
val Color.Companion.Grey500 get() = Color(0xFF9E9E9E)

@Stable
val Color.Companion.Grey600 get() = Color(0xFF757575)

@Stable
val Color.Companion.Grey700 get() = Color(0xFF616161)

@Stable
val Color.Companion.Grey800 get() = Color(0xFF424242)

@Stable
val Color.Companion.Grey900 get() = Color(0xFF212121)

// Blue Grey
@Stable
val Color.Companion.BlueGrey50 get() = Color(0xFFECEFF1)

@Stable
val Color.Companion.BlueGrey100 get() = Color(0xFFCFD8DC)

@Stable
val Color.Companion.BlueGrey200 get() = Color(0xFFB0BEC5)

@Stable
val Color.Companion.BlueGrey300 get() = Color(0xFF90A4AE)

@Stable
val Color.Companion.BlueGrey400 get() = Color(0xFF78909C)

@Stable
val Color.Companion.BlueGrey500 get() = Color(0xFF607D8B)

@Stable
val Color.Companion.BlueGrey600 get() = Color(0xFF546E7A)

@Stable
val Color.Companion.BlueGrey700 get() = Color(0xFF455A64)

@Stable
val Color.Companion.BlueGrey800 get() = Color(0xFF37474F)

@Stable
val Color.Companion.BlueGrey900 get() = Color(0xFF263238)

